<template>
  <ProjectWall v-if="resource && resource.projects" :projects="resource.projects" />
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import ProjectWall from 'beisheim/components/elements/project-wall'

export default {
  components: {
    ProjectWall
  },
  mixins: [ editable ]
}
</script>
